
<!-- controllo se link è esterno, controllo la sessione, mostro login o dialog senza bottoni -->
<!-- login MFA -->

<p-dialog class="dialog-maximized" [modal]="true" [closable]="!standalone" [maximizable]="true" [styleClass]="standalone ? 'standalone-dialog' : ''" [resizable]="false" [(visible)]="showFortinetDetails"
#myDialog (onShow)="onDialogShow(myDialog)" [style]="{ width: '100%', height: '100%' }">
    <ng-template pTemplate="header">
      <div *ngIf="standalone" class="standalone-logo-header">
        <img src="assets/img/brand/awp.png" alt="AWP" />
      </div>
      <span *ngIf="!standalone">Dettaglio Fortinet</span>
    </ng-template>
<div class="ml-4 mr-4">
<div *ngIf="overlayVisible()" class="page-overlay"></div>

<div id="device-menu" class="floatMenu fixed top-[45px] z-[1000]">

<p-button (click)="menu.toggle($event)" severity="primary" [raised]="true" size="small" ><fa-icon [icon]="['fas', 'ellipsis-vertical']"></fa-icon> Device Menu</p-button>
<p-menu #menu [model]="items" [popup]="true" appendTo="device-menu" />
<p-button class="ml-2" (click)="refreshData(frazionario)" severity="primary" [raised]="true" size="small" ><fa-icon [icon]="['fas', 'refresh']"></fa-icon> Refresh</p-button>
</div>
<br><br>
<div class="flex flex-wrap gap-2 mb-2 mt-4" #workflow> <!-- info frazionario -->
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'bank']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Frazionario</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.installation?.Frazionario}} - Fascia {{itemDetails()?.frazionarioDetails?.FasciaSede}}</h6>
    <h5 class="text-[0.8rem] m-0">{{itemDetails()?.frazionarioDetails?.Denominazione}}</h5>
    <p-skeleton *ngIf="!itemDetails()?.installation?.Frazionario" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'server']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Cella</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.installation?.Cella}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.installation?.Cella" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}" [ngClass]="{'p-fieldset-danger': ((itemDetails()?.frazionarioDetails?.step_name?.includes('Retry')|| itemDetails()?.frazionarioDetails?.step_name == 'Policy Group Association') && (itemDetails()?.frazionarioDetails?.TaskError || itemDetails()?.frazionarioDetails?.WorkflowError))}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'sitemap']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Workflow</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.frazionarioDetails?.step_name}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.frazionarioDetails?.step_name" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Installazione SDWAN</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.installation?.DataInstallazione}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.installation?.DataInstallazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
      <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Migrazione SDWAN</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.installation?.DataMigrazione}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.installation?.DataMigrazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
</div>
<div *ngIf="itemDetails()?.migrationNRD && itemDetails()?.migrationNRD !== null" class="flex flex-wrap gap-2 mb-2 mt-4" #workflow2> <!-- info 2 frazionario -->
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'globe']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">NRD</span>
        </div>
    </ng-template>
  <ng-container *ngIf="itemDetails()?.migrationNRD?.DataMigrazione; else showFrazionario">
    <fa-icon [icon]="['fas', 'check']" class="text-green-500 text-xl"></fa-icon>
  </ng-container>
    <ng-template #showFrazionario>
    <h6 class="info-card-title">-</h6>
  </ng-template>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'server']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Carrier</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.migrationNRD?.Carrier}} - {{itemDetails()?.migrationNRD?.Classificazione}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.migrationNRD?.Carrier" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
      <ng-template #header>
        <div class="flex items-center gap-2 px-2">
            <fa-icon [icon]="['fas', 'phone']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Circuito</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.migrationNRD?.Circuito}} </h6>
    <p-skeleton *ngIf="!itemDetails()?.migrationNRD?.Circuito" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
              <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Pianificazione NRD</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.migrationNRD?.DataPianificata | date: 'yyyy-MM-dd'}}</h6>
    <p-skeleton *ngIf="!itemDetails()?.migrationNRD?.DataPianificata" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
  <div class="flex-1 min-w-0 flex">
    <p-fieldset class="info-card w-full" [style]="{'text-align': 'center', 'padding': '0'}">
       <ng-template #header>
        <div class="flex items-center gap-2 px-2">
           <fa-icon [icon]="['fas', 'calendar']" class="text-fq-primary"></fa-icon>
            <span class="font-bold">Migrazione NRD</span>
        </div>
    </ng-template>
    <h6 class="info-card-title">{{itemDetails()?.migrationNRD?.DataMigrazione | date: 'yyyy-MM-dd HH:mm' }}</h6>
    <p-skeleton *ngIf="!itemDetails()?.migrationNRD?.DataMigrazione" height="23px"></p-skeleton>
    </p-fieldset>
  </div>
</div>
<div class="flex flex-wrap inline">
<p-panel [toggleable]="true" [style]="{'padding': '0'}" class="p-panel-danger" [collapsed]="true" *ngIf="itemDetails()?.frazionarioDetails?.TaskError && (itemDetails()?.frazionarioDetails?.step_name?.includes('Retry')|| itemDetails()?.frazionarioDetails?.step_name == 'Policy Group Association')">
    <ng-template #header>
        <div class="flex items-center gap-2">
            <span class="font-bold">vManage Error</span>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex items-center gap-2">


            </div>
            <span class="text-surface-500 dark:text-surface-400">Updated: {{ convertDate(itemDetails()?.frazionarioDetails?.TaskError?.lastUpdateTime) }}</span>
        </div>
    </ng-template>

        <p-table [value]="itemDetails()?.frazionarioDetails?.TaskError?.activity" stripedRows  [size]="'small'">
            <ng-template pTemplate="body" let-error>
                <tr>
                    <td>{{ error }}</td>
                </tr>
            </ng-template>
        </p-table>
</p-panel>
</div>
<div class="flex flex-wrap inline">
<p-panel [toggleable]="true" [style]="{'padding': '0'}" class="p-panel-danger" [collapsed]="true" *ngIf="itemDetails()?.frazionarioDetails?.WorkflowError && (itemDetails()?.frazionarioDetails?.step_name?.includes('Retry') || itemDetails()?.frazionarioDetails?.step_name == 'Policy Group Association')">
    <ng-template #header>
        <div class="flex items-center gap-2">
            <span class="font-bold">Workflow Error</span>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div class="flex items-center gap-2">


            </div>
            <span class="text-surface-500 dark:text-surface-400">Updated: {{ convertDate(itemDetails()?.frazionarioDetails?.TaskError?.lastUpdateTime) }}</span>
        </div>
    </ng-template>

        <div *ngIf="itemDetails()?.frazionarioDetails?.WorkflowError != null">
        <div [innerHTML]="itemDetails()?.frazionarioDetails?.WorkflowError?.errorMessage" class="mb-4 mt-3 ml-3 mr-3"></div>
      </div>
</p-panel>
</div>
    <div class="flex-1 min-w-0 ml-1 mr-1">
<div class="flex flex-wrap mb-2" *ngIf="true" >
          <div #healthcheck class="flex-1 min-w-0 mr-1 ml-1 fq-card fuseqCard m-0 p-0">
              <div class="fq-card-header fuseqCardHeader flex justify-between items-center">
       <span class="uppercase!">Health Check</span>
        <div class="mr-2 flex h-full items-center gap-1">
          <span class="flex h-6 items-center rounded border border-fq-border bg-fq-surface-muted px-2 text-xs font-normal whitespace-nowrap text-fq-text-3">Interval</span>
   <select #mySelectSla
            [(ngModel)]="timeSlaRange" (change)="onTimeSlaChange($event)" class="fq-form-control h-6 w-[8rem] px-2 py-0 text-xs text-center">
      <option value="10min">10 Min</option>
      <option value="30min">30 Min</option>
      <option value="1h">1 Hour</option>
      <option value="4h">4 Hours</option>
      <option value="8h">8 Hours</option>
      <option value="24h">1 Day</option>
      <option value="lastWeek">Last Week</option>
    </select>
  </div>
        </div><div class="fq-card-body fuseqCardBody">
      <div class="sd-wan-container">
    <!--  <h3>Health Check</h3>-->
      <div class="header text-center uppercase">
        <div class="name">Interface/Tunnel</div>
        <div  class="timeline justify-center items-center">Health Check Status</div>
      </div>
      <div class="healthTable" #tunnels>
      <div *ngFor="let iface of interfaces1()" class="row">
      <div  class="name text-center"><i *ngIf="iface.tunnelStatus === 'up'" class="fa-regular fa-circle-up fa-2xl textGreen tunnelStatus"> </i><i *ngIf="iface.tunnelStatus === 'down'" class="fa-regular fa-circle-down fa-2xl textRed tunnelStatus"></i> {{ iface.name }}</div>

      <div class="timeline">
        <div
          *ngFor="let seg of iface.status_sla; let i = index"
          class="seg"
          [ngClass]="seg"
           [pTooltip]="getTooltipSegment(iface, seg, i)"
        tooltipPosition="top"
            (click)="onSegmentClick(iface, seg, i)">
        </div>
      </div>
    </div>
    </div>
    </div>
        <p-dialog [(visible)]="dialogInfoChart" [modal]="true" [draggable]="false" [style]="{width: '600px'}" header="Health Check Detail" [closable]="true" (onHide)="closeDialog()">
          <div class="bottom-details">
            <span class="float-left ml-[15px]"><b>Interface: {{interfaceDetails}}</b></span>
            <button pButton type="button" [label]="extendedView ? 'Vista Compatta' : 'Vista Estesa'" icon="pi pi-external-link" (click)="toggleView()" class="px-2! py-2!">
            </button>
          </div>
        <div class="sd-wan-container">
          <div *ngIf="!extendedView && segmentGroups.length"
              class="simple-grid">
            <div class="grid-header">
              <div class="cell">TIMESTAMP</div>
              <div class="cell"
                  *ngFor="let col of segmentGroups[0]">
                {{ col.sla_name }}
              </div>
            </div>
            <div class="grid-row"
                *ngFor="let group of segmentGroups">
              <div class="cell">
              {{ formatTimestamp(group[0].timestamp) }}
              </div>
              <div class="cell status-cell"
                  *ngFor="let item of group"
                    [ngClass]="['seg', item.sla_status]">
              </div>
            </div>
          </div>
        </div>
          <div *ngIf="extendedView && segmentGroups.length" class="-mt-4">
            <div class="text-center mb-4">
        <button pButton type="button" (click)="!isKoFilterDisabled && (showOnlyKo = !showOnlyKo)" [class.active-filter]="showOnlyKo"
        *ngIf="!isKoFilterDisabled" [label]="showOnlyKo ? 'Mostra tutto'  : 'Mostra solo KO (' + koTimestampsCount + ' di ' + segmentGroups.length + ')'"  class="px-2! py-2!"></button>
          </div>
          <ng-container *ngFor="let group of segmentGroups">
            <div *ngIf="!showOnlyKo || hasKo(group)"
         class="timestamp-block">
          <div [class.timestamp-ko]="hasKo(group)" class="timestamp-title text-center text-base">
        {{ formatTimestamp(group[0].timestamp) }}
      </div>
      <div class="sd-wan-container">
        <div class="sd-row sd-header">
          <div class="sd-cell key-col">DETAILS</div>
          <div class="sd-cell value-col"
               *ngFor="let item of group">
            {{ item.sla_name }}
          </div>
        </div>
        <div class="sd-row" *ngFor="let key of segmentKeys">
          <div class="sd-cell">
            <b>{{ key | titlecase }}</b>
          </div>
          <div class="sd-cell value-col"
               *ngFor="let item of group">
            <div *ngIf="key === 'sla_status'" class="seg" [ngClass]="item[key]"></div>
            <span *ngIf="key !== 'sla_status'" [ngClass]="getMetricClass(item, key)">
              {{ item[key] }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
        </p-dialog>
            </div>
        </div>
        </div>
<div class="flex flex-wrap mt-2 mb-2" *ngIf="slaCharts().length">
      <div class="fq-card-header fuseqCardHeader flex justify-between items-center">
       <span class="uppercase!"> SLA Health Check</span>
        <div class="mr-2 flex gap-1">
   <button class="inline-flex items-center justify-center gap-1 px-3 py-1 text-xs font-semibold rounded border border-white text-white hover:bg-fq-primary hover:text-white cursor-pointer transition-all switch-btn" (click)="openTable()"><fa-icon [icon]="['fas', 'expand']" [ngClass]="view() ? 'fa-compress' : 'fa-expand'" class="mr-2"></fa-icon><span>{{ view() ? 'Close' : 'Espandi' }}</span>
   </button>
  </div>
  </div>
  <div class="flex-1 min-w-0 fq-card fuseqCard">
    <div *ngIf="view()" class="sla-grid-2cols">
<div class="sla-card-toggle" *ngFor="let sla of slaCharts(); let i = index"
     [class.full-width]="isFullExpanded()[i]">
  <div class="card-header-mini flex justify-between p-3">
    <h6>{{ sla.slaName }}</h6>
       <button class="inline-flex items-center justify-center gap-1 px-3 py-1.5 text-sm font-semibold rounded cursor-pointer transition-all" [ngClass]="isFullExpanded()[i] ? 'bg-fq-primary text-white hover:bg-[#1f65be]' : 'border border-fq-primary text-fq-primary hover:bg-fq-primary hover:text-white'" (click)="toggleFull(i)">
  <i  [class.pi-chevron-down]="!isFullExpanded()[i]"  [class.pi-chevron-up]="isFullExpanded()[i]" class="pi leading-none mr-[0.3rem]"></i>
  <span>{{ isFullExpanded()[i] ? 'Close' : 'Expand' }}</span>
</button>
  </div>
  <div echarts [options]="sla.option"
       class="chart-full-toggle"
       [style.height.px]="isFullExpanded()[i] ? 850 : 380">
  </div>
</div>
    </div>
  </div>
</div>
      </div>
<p-skeleton styleClass="mt-2 mb-2" *ngIf="rawData().length === 0" height="400px"></p-skeleton>

<!--sensors
<div class="row g-0 mb-3">
  <div #sensors class="row w-full md:w-full px-3 md:justify-center flex gap-[5px]">
      <div *ngFor="let sensor of sensorsList" class="fq-card bg-fq-secondary mb-0 rounded-[1rem 1rem 1rem]">
        <div class="flex">
          <i class="{{sensor.icon}} mt-[11px] ml-3 text-fq-primary"></i>
          <div class="mr-[-7px] mt-[-1px]"> <span class="greyCard">{{sensor.label}}</span></div>
          <p-badge class="badgeRadius glow clickable" [value]="sensor.value"></p-badge>
        </div>
      </div>
    </div>
</div>-->



<div class="flex flex-wrap gap-0 mt-3" >
  <div class="w-1/4" >
  <div #fortigatedetails class="fq-card fuseqCard ml-1 mb-2 h-auto m-0 p-0">
        <div class="fq-card-header fuseqCardHeader">
            Fortigate Details
        </div>
        <div class="fq-card-body fuseqCardBody">
<p-table stripedRows *ngIf="itemDetails()?.device" [value]="deviceMap()" class="p-datatable-sm">
  <ng-template pTemplate="body" let-row>
    <tr>
      <td><b>{{row.header}}</b></td>
      <td>{{ row.value }}</td>
    </tr>
  </ng-template>
</p-table>
<p-table *ngIf="itemDetails() == null" class="p-datatable-sm" [value]="fakeData">
  <ng-template pTemplate="body" let-fake>
    <tr>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>
</div>

  </div>

  <div #fexdetails class="fq-card fuseqCard ml-1 mt-2 h-auto m-0 p-0">
         <div class="fq-card-header fuseqCardHeader header-flex">
          <span>FEX Details</span>
      <div class="right-actions mr-2">
        <button type="button" class="inline-flex items-center justify-center gap-1 rounded border border-white px-3 py-1 text-xs font-semibold text-white transition-all hover:bg-fq-primary hover:text-white cursor-pointer" (click)="confirmRebootFex()">
          <fa-icon [icon]="['fas', 'refresh']" class="mr-1"></fa-icon><span>Reboot</span>
        </button>
      </div>
        </div>
        <div class="fq-card-body fuseqCardBody">
<p-table stripedRows *ngIf="itemDetails()?.fex" [value]="deviceMapFEX()" class="p-datatable-sm">
  <ng-template pTemplate="body" let-row>
    <tr>
      <td><b>{{row.header}}</b></td>
      <td>{{ row.value }}</td>
    </tr>
  </ng-template>
</p-table>
<p-table *ngIf="itemDetails() == null" class="p-datatable-sm" [value]="fakeData">
  <ng-template pTemplate="body" let-fake>
    <tr>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>
</div>
  </div>
<div *ngIf="filteredInterfaces().length > 0" #interfacesStatus class="fq-card fuseqCard ml-1 mt-2 m-0 p-0">
    <div class="fq-card-header fuseqCardHeader">
      Interfaces Status Control
</div><div class="fq-card-body fuseqCardBody">
<p-table stripedRows [value]="filteredInterfaces()" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Administrative</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-interface>
    <tr>
      <td class="text-center">{{interface.name}}</td>
      <td class="text-center">
  <label class="switch">
    <input type="checkbox" [checked]="interface.admin_status" (change)="toggleStatus(interface, 'admin_status')">
    <span class="slider round"></span>
  </label>
</td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!filteredInterfaces() || filteredInterfaces().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
</div>
<div #tunnelsHidden *ngIf="false" class="fq-card fuseqCard ml-1 mt-2 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Tunnels
        </div><div class="fq-card-body fuseqCardBody overflow-x-auto">
          <p-table stripedRows *ngIf="itemDetails()?.tunnels" [value]="itemDetails()?.tunnels" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <!--th>Connection</th-->
      <th>Status</th>
      <!--th>Common Name</th-->

    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tunnel>
    <tr >
      <td class="text-center">{{ tunnel.name}}</td>
     <!--td style="text-align: center;">{{ tunnel.connection_count}}</td-->
    <td class="text-center"><i *ngIf="tunnel.status === 'up'" class="fa-regular fa-circle-up fa-2xl textGreen"> </i><i *ngIf="tunnel.status === 'down'" class="fa-regular fa-circle-down fa-2xl textRed"></i></td>
     <!--td style="text-align: center;">{{ tunnel.username}}</td-->
    </tr>
  </ng-template>
</p-table>
  <p-table *ngIf="itemDetails() == null || itemDetails()?.tunnels?.length === 0" class="p-datatable-sm" [value]="fakeData">
  <ng-template pTemplate="body" let-fake>
    <tr>
      <td><p-skeleton></p-skeleton></td>
      <td><p-skeleton></p-skeleton></td>
    </tr>
  </ng-template>
</p-table>
  </div>
        </div>
</div>
      <div class="w-3/4">

<div class="flex flex-wrap gap-0 mb-2" *ngIf="true" > <!-- chart  -->
  <div #traffic class="flex-1 min-w-0 fq-card fuseqCard ml-1 mr-1 m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Traffic History
        </div><div class="fq-card-body fuseqCardBody overflow-x-auto">
  <div class="w-full flex flex-wrap justify-end gap-1 mt-2">

      <div class="flex items-stretch -mr-px"><span class="flex items-center px-3 text-sm font-normal text-fq-text-3 bg-fq-surface-muted border border-fq-border rounded whitespace-nowrap max-w-[95px]">Interval</span></div>
    <select #mySelect
            [(ngModel)]="timeRange"
            (change)="onTimeRangeChange($event, 'timeRange')" class="fq-form-control w-[10rem] text-center">
      <option value="hour">1 Hour</option>
      <option value="day">24 Hours</option>
      <option value="week">Last Week</option>
    </select>

    <div class="flex items-stretch -mr-px ml-2"><span class="flex items-center px-3 text-sm font-normal text-fq-text-3 bg-fq-surface-muted border border-fq-border rounded whitespace-nowrap max-w-[95px]">Interface</span></div>
    <select #mySelect_int
            [(ngModel)]="chartInterface"
            (change)="onTimeRangeChange($event, 'chartInterface')" class="fq-form-control w-[10rem] text-center">
      <option *ngFor="let iface of interfaceList()" [value]="iface">{{ iface }}
      </option>
    </select>
      </div>
    <div class="w-full flex justify-end">
        <div class="text-start">
      Max RX: <span class="font-bold text-fq-primary">{{ maxRX() }}</span> |
      Max TX: <span class="font-bold text-fq-primary">{{ maxTX() }}</span>
    </div>
      </div>
  <echarts *ngIf="chartOptionBanda()"
         [options]="chartOptionBanda()"

         class="chart w-full h-[350px] block"></echarts>
  </div>
  </div>
</div>

<div class="flex flex-wrap gap-0">



      <div class="w-1/2">
        <div class="flex flex-wrap gap-0 mt-2 mb-2" >
          <div #trafficbytes class="flex-1 min-w-0 mr-1 ml-1 fq-card fuseqCard m-0 p-0">
                <div class="fq-card-header fuseqCardHeader">
                      Traffic Bytes
                </div>
                <div class="fq-card-body fuseqCardBody">
                          <p-table *ngIf="trafficBytes()?.length > 0"  [value]="trafficBytes()" class="p-datatable-sm" styleClass="sdwan-rules-table">
                            <ng-template pTemplate="header">
                              <tr>
                                <th>Interface</th>
                                <th>Received</th>
                                <th>Sent</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-traffic>
                              <tr>
                                <td class="text-center">{{ traffic.name }}</td>
                                <td tooltip="{{traffic.rx_bytes}}" tooltipPosition="top" class="text-center">{{ convertBytes(traffic.rx_bytes) }}</td>
                                <td tooltip="{{traffic.tx_bytes}}" tooltipPosition="top" class="text-center">{{ convertBytes(traffic.tx_bytes) }}</td>
                              </tr>
                            </ng-template>
                        </p-table>
                  <p-skeleton *ngIf="!itemRules() || itemRules()?.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                </div>
            </div>
        </div>
      </div>

      <div class="w-1/2">
        <div class="flex flex-wrap gap-0 mt-2 mb-2" >
          <div #sdwanrules class="flex-1 min-w-0 mr-1 ml-1 fq-card fuseqCard m-0 p-0">
                <div class="fq-card-header fuseqCardHeader">
                      SD-WAN Rules
                </div>
                <div class="fq-card-body fuseqCardBody">
                          <p-table *ngIf="itemRules()?.length > 0"  [value]="itemRules()" class="p-datatable-sm" styleClass="sdwan-rules-table">
                            <ng-template pTemplate="header">
                              <tr>
                                <th>SD-WAN Rule</th>
                                <th>Hits Count</th>
                                <th>Members</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rule>
                              <tr>
                                <td class="text-center">{{ rule.name }}</td>
                                <td class="text-center">{{ rule.hit_count }}</td>
                                <td class="text-center flex flex-col"  >
                                  <span *ngFor="let intf of rule.dst_interfaces" class="me-2" [ngStyle]="{'font-weight': intf.active ? 'bold' : 'normal','font-size': intf.active ? '1rem' : '0.8rem'}">{{ intf.name }}
                            <i *ngIf="intf.active" class="pi pi-check-circle textGreen text-base"></i>
                            </span>
                                </td>
                              </tr>
                            </ng-template>
                        </p-table>
                  <p-skeleton *ngIf="!itemRules() || itemRules()?.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                  <p-skeleton *ngIf="!itemDetails()?.interfaces || itemDetails()?.interfaces.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                </div>
            </div>
        </div>
      </div>
</div>




    </div>

</div>


 <div class="flex flex-wrap mt-2 mb-2" >
          <div #interfaces class="flex-1 min-w-0 mr-1 ml-1 fq-card fuseqCard m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Interfaces
        </div><div class="fq-card-body fuseqCardBody">
               <!--<p-table *ngIf="itemDetails() && itemDetails().interfaces" [value]="itemDetails()?.interfaces" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Monitoring</th>
      <th>Mac</th>
      <th>Ip</th>
      <th>Link</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-interface>
    <tr>
      <td class="text-center">{{ interface.name }}</td>
       <td class="text-center"><i *ngIf="interface.monitor_bandwidth === true" class="fa-solid fa-display textGreen"> </i><i *ngIf="interface.monitor_bandwidth === false" class="fa-solid fa-display textRed"></i></td>
      <td class="text-center">{{ interface.mac }}</td>
      <td class="text-center">{{ interface.ip }}</td>
      <td class="text-center"><i *ngIf="interface.link === true" class="fa-regular fa-circle-up fa-2xl textGreen"> </i><i *ngIf="interface.link === false" class="fa-regular fa-circle-down fa-2xl textRed"></i></td>
    </tr>
  </ng-template>
</p-table>-->
  <fq-table  class="interfaces-table" *ngIf="newInterfaces()" [tableId]="'byInterfaces'" [value]="newInterfaces()" [showSearch]="true" [rowGroupMode]="'subheader'" [showOption]="false" [groupRowsBy]="'parent'" [expandableRows]="true"
        [columns]="[{field: 'name', header: 'Name'}, {field: 'type', header: 'Type'}, {field: 'monitor_bandwidth', header: 'Monitoring'}, {field: 'mac', header: 'Mac'}, {field: 'ip', header: 'IP'},{field: 'admin_status', header: 'Administrative'},{field: 'oper_status', header: 'Operative'}]">
  <ng-template #body let-interface>
    <tr >
      <td class="text-center">{{interface.name}}</td>
      <td  class="text-center">{{interface.type}}  <i [class]="getInterfaceIcon(interface.type)"></i></td>
      <td class="text-center"><i *ngIf="interface.monitor_bandwidth === true" class="fa-solid fa-display textGreen"> </i><i *ngIf="interface.monitor_bandwidth === false" class="fa-solid fa-display textRed"></i></td>
      <td  class="text-center">{{interface.mac }}</td>
      <td class="text-center">{{ interface.ip }}</td>
      <td class="text-center"><i *ngIf="interface.admin_status === true" class="fa-regular fa-circle-up fa-2xl textGreen"> </i><i *ngIf="interface.admin_status === false" class="fa-regular fa-circle-down fa-2xl textRed"></i></td>
       <td class="text-center"><i *ngIf="interface.oper_status === true" class="fa-regular fa-circle-up fa-2xl textGreen"> </i><i *ngIf="interface.oper_status === false" class="fa-regular fa-circle-down fa-2xl textRed"></i></td>
    </tr>
  </ng-template>
</fq-table>
<p-skeleton *ngIf="!newInterfaces()|| newInterfaces().length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
        </div>


<div class="flex flex-wrap mt-2 mb-2">

            <div #switch class="flex-1 min-w-0 ml-1 mr-1 fq-card fuseqCard m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            Switch {{Marca()}}: {{IndirizzamentoSwitch()}}
        </div><div class="fq-card-body fuseqCardBody">
          <p-skeleton *ngIf="gigabitPorts().length === 0" height="140px"  styleClass="mt-2"></p-skeleton>
          <div  class="ml-2 mr-2 mt-2 w-[500px] text-center place-self-center">
<div class="switch-grid" *ngIf="ports3_4() && ports3_4().length > 0">
  <!-- solo 3 e 4 -->
  <div class="port-label-row">
    <div *ngFor="let port of ports3_4()" class="port-label">{{port.porta}}</div>
  </div>
  <div class="port-row">
    <div *ngFor="let port of ports3_4()" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato == 'Enabled' ? 'up' : 'down'">
      </fa-icon>
    </div>
  </div>
  <div class="port-label-row">
    <div *ngFor="let port of ports3_4()" class="port-label">vlan: {{ port.vlan_effettiva }} - {{port.mode}}</div>
  </div>
  </div>
  </div>
                <div class="switch-grid" *ngIf="gigabitPorts() && gigabitPorts().length > 0">
  <!-- Etichette numeriche -->
  <div class="port-label-row">
    <div *ngFor="let i of firstArray()" class="port-label">{{ i }}</div>
  </div>
  <div class="port-row">
    <div *ngFor="let port of gigabitPorts().slice(0,firstArray().length)" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato" pTooltip="{{ getTooltip(port) }}" tooltipPosition="top">
      </fa-icon>
    </div>
  </div>

  <!-- Seconda riga -->

  <div class="port-row">
    <div *ngFor="let port of gigabitPorts().slice(firstArray().length,gigabitPorts().length)" class="port-cell">
      <fa-icon [icon]="['fas', 'ethernet']" [ngClass]="port.stato" pTooltip="{{ getTooltip(port) }}" tooltipPosition="top">
      </fa-icon>
    </div>
  </div>
  <div class="port-label-row">
    <div *ngFor="let i of secondArray()" class="port-label">{{ i }}</div>
  </div>
</div>

</div>
            </div>
        </div>


        <fq-dialog-nav #speedtest [sections]="detailSections" [(active)]="detailTab" variant="pill" enclosed>
          <div *ngIf="detailTab === 'tasks'" class="flex flex-wrap">
            <div #tasks class="flex-1 min-w-0 fq-card fuseqCard m-0 p-0">
              <div class="fq-card-header fuseqCardHeader">
            FortiManager Tasks
        </div><div class="fq-card-body fuseqCardBody">
                <p-table *ngIf="itemDetails() && itemDetails().tasks" [value]="itemDetails()?.tasks" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <tr>
      <th>Start Time</th>
      <th>Task</th>
      <th>Status</th>
      <th>Last Activity</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-task>
    <tr>
      <td class="text-center">{{ (task.Payload && task.Payload['startTime'] ? convertDate(task.Payload['startTime']) : task.Create_Date) | date: 'yyyy-MM-dd HH:mm' }}</td>
      <td class="text-center">{{ task.Task }}</td>
      <td class="text-center">{{ task.Status }}</td>
      <td class="text-center">{{ task.Payload && task.Payload['currentActivity'] ? task.Payload['currentActivity'] : task.Payload?.data ? task.Payload.data[0] ? task.Payload.data[0]?.currentActivity : '' : '' }}</td>
      <td class="text-center"><p-button icon="pi pi-cog" severity="primary" rounded text (click)="showTaskDialog(task)" /></td>
    </tr>
  </ng-template>
</p-table>
<p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
                <p-skeleton *ngIf="!itemDetails()?.tasks || itemDetails()?.tasks.length === 0" height="23px"  styleClass="mt-2"></p-skeleton>
</div>
            </div>
        </div>





          <div *ngIf="detailTab === 'speedtest-new'" class="flex flex-wrap">
            <app-speedtest-history-table class="w-full" [frazionario]="itemDetails()?.installation?.Frazionario"></app-speedtest-history-table>
          </div>
          <div *ngIf="detailTab === 'speedtest-old'" class="flex flex-wrap">
            <speed-test-forti [fraz]="itemDetails()?.installation?.Frazionario" class="w-full ml-[0.2rem] pr-[0.2rem]"></speed-test-forti>
          </div>
        </fq-dialog-nav>
      <div class="flex flex-wrap mt-2 mb-2" *ngIf="rawData().length > 0" #cpumem> <!-- chart -->
  <echarts [options]="chartOption()" class="chart w-full"></echarts>
</div>
      </div>
</p-dialog>





<p-dialog header="{{dialogTask?.Task}}" [(visible)]="visible" [modal]="true" [style.width]="'50rem'" [style.padding]="'unset'">
    <p-table [value]="dialogTask?.activity_data" stripedRows  [size]="'small'" [style]="{'margin-bottom': '1rem'}">
        <ng-template pTemplate="body" let-activity>
            <tr>
                <td>{{ activity }}</td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
        <tr>
            <td colspan="1">No data for this task.</td>
        </tr>
    </ng-template>
    </p-table>
</p-dialog>
<p-dialog header="Reboot History" [(visible)]="visibleReboot" [modal]="true" [style.width]="'50rem'" [style.padding]="'unset'">
    <p-table *ngIf="itemDetails() && itemDetails().rebootHistory" [value]="itemDetails()?.rebootHistory" class="p-datatable-sm" [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="body" let-reboot>
    <tr>
      <td>{{ convertDate(reboot['reboot_date_time-date']) }}</td>
      <td>{{ reboot.reboot_reason }}</td>
    </tr>
  </ng-template>
</p-table>
</p-dialog>
